module.exports = __webpack_public_path__ + "img/new_user_coupon.1ebfd721.png";